import { useLayoutStore } from '../../state/layout.store'
import { Button, Form, InputGroup, Modal } from 'react-bootstrap'
import React, { useCallback, useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import PackageModel from '@geartrack/shared-lib/dist/PackageModel'
import { copyToClipboard, getUrl } from '../../libraries/utils'
import { toast } from 'react-toastify'

const SharePackageModal = () => {
  const sharePkg = useLayoutStore(state => state.packageShareModal)
  const sharePkgToggle = useLayoutStore(state => state.packageShareModalToggle)

  const onClose = useCallback(() => {
    sharePkgToggle(null)
  }, [sharePkgToggle])

  if (!sharePkg) {
    // performance improvement
    return null
  }

  return (
    <Modal size="lg" show={true} onHide={onClose}>
      <ShareDialogBody onClose={onClose} pkg={sharePkg} />
    </Modal>
  )
}

const ShareDialogBody = ({ onClose, pkg }) => {
  const { t } = useTranslation('packages')

  const url = useMemo(() => {
    return getPackageShareUrl(pkg)
  }, [pkg])

  const onClick = useCallback(() => {
    const success = copyToClipboard(url)

    console.log(success)
    if (success) {
      toast.success(t('share modal.toast success'))
      onClose()
    }
  }, [onClose, url, t])

  return (
    <>
      <Modal.Header closeButton>
        <Modal.Title>{t('share modal.title')}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form.Group controlId={'url'} className="mb-3">
          <Form.Label className="font-weight-bold">Link</Form.Label>
          <InputGroup className="mb-3">
            <Form.Control disabled value={url} />
            <Button variant="primary" onClick={onClick}>
              <i className="fa fa-copy me-1" /> {t('share modal.copy')}
            </Button>
          </InputGroup>
          <Form.Text className="text-muted">{t('share modal.helper text')}</Form.Text>
        </Form.Group>
      </Modal.Body>

      <Modal.Footer>
        <Button variant="secondary" onClick={onClose}>
          {t('share modal.close')}
        </Button>
      </Modal.Footer>
    </>
  )
}

const getPackageShareUrl = (pkg: PackageModel) => {
  const qs = {}

  if (pkg.description) {
    qs['description'] = pkg.description
  }

  if (pkg.extraData) {
    for (let extraDataKey in pkg.extraData) {
      qs[extraDataKey] = pkg.extraData[extraDataKey]
    }
  }

  const qsString = new URLSearchParams(qs).toString()

  let url = getUrl(`/share/${encodeURIComponent(pkg.trackingId)}`)

  if (qsString) {
    url += '?' + qsString
  }

  return url
}

export default SharePackageModal
